import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const FieldRow = styled.div({
  display: 'flex',
  width: '100%'
})

export const AttachmentFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop:'1rem',

  '>div:last-child':{
    marginRight:'0 !important'
  },

  '.sectionLeft': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginRight: '15px',
  },

  '.sectionRight': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  '.fileInput':{
    width:'100%'
  }
})

export const AttachmentInfoContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex:1,

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const FileCont = styled.div((props)=>({
  display:'flex',
  marginTop:'0.5rem',

  '>div:first-child':{
    flex:1
  },
  '>div:last-child':{
    flex:4
  },

  '.titleFile':{
    fontWeight:'normal',
    display:'flex',
    justifyContent:'flex-end'
  },

  '.fileItem':{
    fontWeight:'normal',
    display:'flex',
    flexDirection:'column',
    'button':{
      marginTop:'0.1rem'
    }
  },

  '.fileName':{
    display:'flex',
    justifyContent:'flex-start',
    wordBreak: 'break-all',
  },

  '.noFile':{
    fontStyle:'italic',
    marginLeft: '1rem'
  },

  '.button':{
    marginLeft:'1rem'
  }
}))